var _path, _rect, _text, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490 490",
    width: 174,
    height: 174,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346 490H144c-21.9 0-39.8-17.9-39.8-39.8V39.8C104.2 17.9 122.1 0 144 0h202c21.9 0 39.8 17.9 39.8 39.8v410.5c0 21.9-17.9 39.7-39.8 39.7zM144 20c-11 0-19.8 8.9-19.8 19.8v410.5c0 11 8.9 19.7 19.8 19.7h202c11 0 19.8-8.9 19.8-19.7V39.8c0-11-8.9-19.8-19.8-19.8H144z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 60,
    width: 220,
    height: 320,
    rx: 15,
    ry: 15
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 245,
    y: 240,
    textAnchor: "middle",
    fontSize: 120,
    fontWeight: "bold"
  }, "#")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 430,
    r: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDid);
export default __webpack_public_path__ + "static/media/Did.0df195ca32ec5b85e83be5e50cb14371.svg";
export { ForwardRef as ReactComponent };